import { action, computed, makeObservable, observable, runInAction } from 'mobx';

import { HttpClient } from 'shared/libs/http';
import { AsyncState } from 'shared/libs/state';
import { ForEmployersPlansResponse, EmployerPlan } from './for-employers.types';

type StoreCallbacks = {
   onError?: (message: string) => void;
};

export class FeatureForEmployersStore {
   readonly loadPlansState = new AsyncState<ForEmployersPlansResponse>();

   plans: EmployerPlan[] = [];

   showRates = false;

   constructor() {
      makeObservable(this, {
         plans: observable,
         showRates: observable,
         loading: computed,
         hasPlans: computed,
         toggleRates: action.bound,
         loadPlans: action.bound,
      });
   }

   get loading(): boolean {
      return this.loadPlansState.status === 'pending';
   }

   get hasPlans(): boolean {
      return this.plans.length > 0;
   }

   toggleRates(): void {
      this.showRates = !this.showRates;
   }

   async loadPlans({ onError }: StoreCallbacks = {}): Promise<void> {
      await this.loadPlansState.run(() => HttpClient.get<ForEmployersPlansResponse>('/plans/listPurchase'), {
         onSuccess: (resp) => {
            const plans = resp.response?.plan;

            if (Array.isArray(plans)) {
               runInAction(() => {
                  this.plans = plans;
               });
               return;
            }

            onError?.(resp.message || 'Could not get membership plan data');
         },
         onError: (error) => {
            onError?.(error.message);
         },
      });
   }
}
